import React from 'react';

import BackIcon from './back-icon';
import { BackLinkRoot } from './back-link.styled';

const BackLink: React.FC<{
  label: string;
  onClick: () => void;
  dataTestId?: string;
}> = ({ label, onClick, dataTestId }) => (
  <BackLinkRoot type="button" onClick={onClick} data-testid={dataTestId}>
    <BackIcon />
    {label}
  </BackLinkRoot>
);

export default BackLink;
